/**
 * brandStore — dünne Lade-/Speicher-Helfer für die Brand-Pages (Backend, Spec §7.2).
 * Reine Delegation an BrandService.
 */

import { BrandService } from './BrandService'
import { brandScope } from '../utils/scope'
import type { Brand, Session } from '../types'

/** Lädt die für die Session sichtbaren Brands (Admin: alle; Brand-Admin: eigene). */
export async function loadBrands(session: Session): Promise<Brand[]> {
  const scope = brandScope(session)
  if (scope.canSeeAllBrands) return BrandService.list()
  if (scope.isBrandAdmin && scope.brandKey) return [await BrandService.get(scope.brandKey)]
  return []
}

/** Lädt eine einzelne Brand über ihren brandKey. */
export async function loadBrand(brandKey: string): Promise<Brand> {
  return BrandService.get(brandKey)
}

/** Speichert eine Brand (PUT-Replace). Payload muss brandKey enthalten (Backend-DTO verlangt ihn). */
export async function saveBrand(brandKey: string, payload: Brand): Promise<Brand> {
  return BrandService.update(brandKey, payload)
}

/** Legt eine neue Brand an. */
export async function createBrand(payload: Brand): Promise<Brand> {
  return BrandService.create(payload)
}
